import { computed, makeObservable } from 'mobx'

import { Collection } from 'modules/core/lib/mobx-rest'
import type Company from 'modules/core/store/models/Company'

import Subscription from 'modules/billing/store/models/Subscription'

class Subscriptions extends Collection<Subscription> {
  constructor(data = []) {
    super(data)
    makeObservable(this, {
      current: computed,
    })
  }

  /**
   * @deprecated Before using this method, consider using the `useCurrentSession` hook since
   * we are trying to move away from using mobx-rest and use GraphQL instead.
   */
  get current(): Subscription {
    const subscription = this.find({
      current: true,
    })

    if (!subscription) {
      throw Error('Error finding subscriptions with current = true')
    }

    return subscription
  }

  model() {
    return Subscription
  }
}

const singleton: Subscriptions = new Subscriptions()

export const companySubscription = (company: Company) => {
  return singleton.find({
    id: company.attributes.subscription_id,
  })
}

/**
 * The company has a paid subscription and was paid via Self-Serve
 *
 * @returns {boolean}
 */
export const companyIsSelfServed = (company: Company) => {
  return !!companySubscription(company)?.isSelfServed
}

export const companyInFreeTrial = (company: Company) => {
  return !!companySubscription(company)?.inFreeTrial
}

export const companyInExpiredFreeTrial = (company: Company) => {
  return !!companySubscription(company)?.inExpiredFreeTrial
}
/**
 * The company is on the Free Trial and belongs to Self-Serve segment.
 * The Segment is defined by the number of seats chosen by the first admin
 * @returns {boolean}
 */
export const companyIsSelfServedOnTrial = (company: Company) => {
  return companyInFreeTrial(company) && !!company.attributes.self_served
}

export default singleton
